/** Shared paste/drop guard, including clipboard items absent from files. */
export const containsImage = (transfer: DataTransfer): boolean => {
  if (
    Array.from(transfer.files).some((file) => file.type.startsWith('image/')) ||
    Array.from(transfer.items ?? []).some((item) =>
      item.type.startsWith('image/')
    )
  )
    return true;
  const html = transfer.getData('text/html');
  return html
    ? Boolean(
        new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector('img, picture, svg, image')
      )
    : false;
};
